import * as THREE from 'three';
import type { SkillEffect } from './skill-effects.js';
import { effectParticles, shadeEffect } from './effect-surfaces.js';
import { smokePuff } from './smoke-puff.js';

/**
 * Game seconds the Assassin stays unseen inside the smoke bomb before its figure stands there whole. Its appearance is
 * the smoke thinning around it: the figure itself never fades, because dithering its materials recompiles their shaders.
 */
export const SNEAK_REVEAL_SECONDS = .18;
/** The smoke bomb outlasts the reveal: it bursts as the Assassin appears and rolls away around it. */
const SMOKE_SECONDS = 1.4;

/** Sneak: a small, dark smoke bomb bursts where the Assassin stands, with a few pale wisps drifting up out of it. */
export function sneakReveal(height: number, radius: number): SkillEffect {
  const group = new THREE.Group(); group.name = 'sneak-reveal';
  const wisps = effectParticles(0xcfc9b8, 14, radius * 1.1, height * 1.1);
  const smoke = smokePuff(height, radius, { seconds: SMOKE_SECONDS, color: 0x5d5954, size: .7, name: 'sneak-smoke' });
  group.add(wisps, smoke.group);
  const zero = new THREE.Vector3();
  return { group, duration: SMOKE_SECONDS * 1000, update(p, _from, to, time = p * SMOKE_SECONDS, ppm = 40) {
    // The bomb goes off on the Assassin, whose figure only takes its place as the cue arrives: the smoke rides with it.
    group.position.copy(to);
    smoke.update(p, zero, zero, time);
    shadeEffect(wisps, time, Math.min(1, time / SNEAK_REVEAL_SECONDS) * (1 - p), p, ppm);
  } };
}
